import apiFetch from '../apiFetch'

export default function (idTipoInstalacion, token) {
  return apiFetch({endPoint: `TipoInstalacion/getTipoInstalacion?idTipoInstalacion=${idTipoInstalacion}`, method: 'GET', body: null, token: token})
}
